export const fontsPacifico = [
  {
    style: "normal",
    urlSet: [
      {
        format: "truetype",
        url: "/fonts/Pacifico-Regular.ttf",
      },
    ],
    weight: "400",
  },
];
